import React, { useCallback, useEffect, useState } from 'react'
import { Button, Label } from 'semantic-ui-react'
import { MaintenanceService } from 'utility'
import { CreateMaintenanceFromFinding } from './CreateMaintenanceFromFinding'
import { MaintenanceTaskDetailModal } from './MaintenanceTaskDetailModal'
import { formatDate } from './maintenance-utils'

/**
 * Ticket page (EAUDITOR-408): the maintenance tasks made from this ticket + "Create maintenance task" (prefilled from
 * the ticket's finding). Hidden quietly when maintenance is not installed (the list call fails).
 */
export const TicketMaintenanceLinks = ({ ticketId }) => {
    const [tasks, setTasks] = useState(null)
    const [creating, setCreating] = useState(false)
    const [openTaskId, setOpenTaskId] = useState(null)

    const load = useCallback(() => {
        if (!ticketId) return
        MaintenanceService.byTicket(ticketId)
            .then(rows => setTasks(Array.isArray(rows) ? rows : []))
            .catch(() => setTasks(null))
    }, [ticketId])

    useEffect(() => {
        load()
    }, [load])

    if (tasks === null) return null

    return (
        <div>
            {tasks.length === 0 && <div style={{ color: '#6b7280', marginBottom: 8 }}>No maintenance task made from this ticket yet.</div>}
            {tasks.map(t => (
                <div key={t.TaskId} style={{ marginBottom: 6 }}>
                    <Label as="a" basic color="teal" onClick={() => setOpenTaskId(t.TaskId)}>
                        {t.Title}
                        <Label.Detail>{t.StageName}</Label.Detail>
                    </Label>
                    <span style={{ color: '#6b7280', fontSize: 12, marginLeft: 6 }}>
                        {t.AssetName} - due {formatDate(t.TaskDue)}
                    </span>
                </div>
            ))}
            <Button type="button" size="small" basic onClick={() => setCreating(true)}>
                Create maintenance task
            </Button>
            {creating && (
                <CreateMaintenanceFromFinding
                    ticketId={ticketId}
                    onClose={created => {
                        setCreating(false)
                        if (created) load()
                    }}
                />
            )}
            <MaintenanceTaskDetailModal
                open={!!openTaskId}
                taskId={openTaskId}
                onClose={changed => {
                    setOpenTaskId(null)
                    if (changed) load()
                }}
            />
        </div>
    )
}
